document.addEventListener('DOMContentLoaded', function () {
  initReveals();
  initCountUp();
  initFaqAccordion();
  initComparadorSlider();
  initGaleriaProducto();
  initVariantePicker();
  initBarraCompra();
  initMarquee();
  initBannerVideoMotion();
  initVideoAutoplayEnScroll();
  initResenasVerMas();
});

/* Revela elementos .qn-reveal cuando entran en pantalla */
function initReveals() {
  var items = document.querySelectorAll('.qn-reveal');
  if (!items.length) return;
  if (!('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('qn-visible'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('qn-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  items.forEach(function (el) { io.observe(el); });
}

/* Cifras animadas: data-qn-count-to="123" */
function initCountUp() {
  var items = document.querySelectorAll('[data-qn-count-to]');
  if (!items.length || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      io.unobserve(el);
      var to = parseFloat(el.getAttribute('data-qn-count-to')) || 0;
      var suffix = el.getAttribute('data-qn-count-suffix') || '';
      var duration = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var value = to % 1 === 0 ? Math.round(to * eased) : (to * eased).toFixed(1);
        el.textContent = value + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.4 });
  items.forEach(function (el) { io.observe(el); });
}

/* Acordeón FAQ accesible */
function initFaqAccordion() {
  var faqs = document.querySelectorAll('.qn-faq-item');
  if (!faqs.length) return;
  faqs.forEach(function (item) {
    var btn = item.querySelector('.qn-faq-pregunta');
    var panel = item.querySelector('.qn-faq-respuesta');
    if (!btn || !panel) return;
    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('qn-faq-item--abierto');
      faqs.forEach(function (other) {
        other.classList.remove('qn-faq-item--abierto');
        var otherBtn = other.querySelector('.qn-faq-pregunta');
        if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('qn-faq-item--abierto');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

/* Comparador de imagen con deslizador (antes/después genérico, si se usa) */
function initComparadorSlider() {
  var wraps = document.querySelectorAll('[data-qn-comparador]');
  wraps.forEach(function (wrap) {
    var handle = wrap.querySelector('.qn-comparador__handle');
    var after = wrap.querySelector('.qn-comparador__after');
    if (!handle || !after) return;
    var dragging = false;
    function setPos(clientX) {
      var rect = wrap.getBoundingClientRect();
      var pct = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width)) * 100;
      after.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
      handle.style.left = pct + '%';
    }
    handle.addEventListener('pointerdown', function (e) { dragging = true; e.preventDefault(); });
    window.addEventListener('pointerup', function () { dragging = false; });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      setPos(e.clientX);
    });
    wrap.addEventListener('click', function (e) { setPos(e.clientX); });
  });
}

/* Galería de producto: miniatura -> imagen principal */
function initGaleriaProducto() {
  var galeria = document.querySelector('[data-qn-galeria]');
  if (!galeria) return;
  var main = galeria.querySelector('[data-qn-galeria-principal]');
  var thumbs = galeria.querySelectorAll('[data-qn-galeria-thumb]');
  if (!main || !thumbs.length) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.getAttribute('data-full');
      if (!src) return;
      main.src = src;
      thumbs.forEach(function (t) { t.classList.remove('qn-thumb--activa'); });
      thumb.classList.add('qn-thumb--activa');
    });
  });
}

/* Selector de variantes: actualiza id oculto, precio y estado agotado */
function initVariantePicker() {
  var form = document.querySelector('[data-qn-form-producto]');
  if (!form) return;
  var dataEl = document.querySelector('[data-qn-variantes-json]');
  var selects = form.querySelectorAll('[data-qn-opcion]');
  if (!dataEl || !selects.length) return;
  var variantes;
  try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var idInput = form.querySelector('input[name="id"]');
  var precioEl = document.querySelector('[data-qn-precio]');
  var precioComparadoEl = document.querySelector('[data-qn-precio-comparado]');
  var submitBtn = form.querySelector('[data-qn-submit]');

  function currentSelection() {
    var vals = [];
    selects.forEach(function (s) { vals.push(s.value); });
    return vals;
  }

  function findVariant() {
    var sel = currentSelection();
    return variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === sel[i]; });
    });
  }

  function money(cents) {
    var moneda = window.Shopify && Shopify.currency ? Shopify.currency.active : 'EUR';
    var idioma = moneda === 'USD' ? 'en-US' : (document.documentElement.lang || 'es');
    return (cents / 100).toLocaleString(idioma, { style: 'currency', currency: moneda });
  }

  function update() {
    var variant = findVariant();
    if (!variant) return;
    if (idInput) idInput.value = variant.id;
    if (variant.featured_media && variant.featured_media.id) {
      var thumbVariante = document.querySelector('[data-qn-galeria-thumb][data-media-id="' + variant.featured_media.id + '"]');
      if (thumbVariante && !thumbVariante.classList.contains('qn-thumb--activa')) thumbVariante.click();
    }
    if (precioEl) precioEl.textContent = money(variant.price);
    var barraPrecio = document.querySelector('[data-qn-barra-precio]');
    if (barraPrecio) barraPrecio.textContent = money(variant.price);
    var barraVariante = document.querySelector('[data-qn-barra-variante]');
    if (barraVariante && variant.title) barraVariante.textContent = variant.title;
    var barraImg = document.querySelector('[data-qn-barra-img]');
    var imgVar = variant.featured_image && variant.featured_image.src;
    if (barraImg && imgVar) barraImg.src = imgVar.replace(/(\.[a-z]+)(\?|$)/i, '_120x120$1$2');
    var notaEl = document.querySelector('.qn-packs__nota[data-notas]');
    if (notaEl) {
      try { var notas = JSON.parse(notaEl.getAttribute('data-notas')); var iv = variantes.indexOf(variant); if (notas[iv]) notaEl.textContent = notas[iv]; } catch (e) {}
    }
    var ofertaEl = document.querySelector('[data-qn-oferta]');
    if (ofertaEl) {
      var despues = (ofertaEl.getAttribute('data-despues') || '').split(',');
      var idxV = variantes.indexOf(variant);
      var precioDespuesEl = document.querySelector('[data-qn-oferta-precio]');
      if (precioDespuesEl && despues[idxV]) precioDespuesEl.textContent = money(parseInt(despues[idxV], 10));
    }
    if (precioComparadoEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        precioComparadoEl.textContent = money(variant.compare_at_price);
        precioComparadoEl.style.display = '';
      } else {
        precioComparadoEl.style.display = 'none';
      }
    }
    if (submitBtn) {
      submitBtn.disabled = !variant.available;
      submitBtn.textContent = variant.available ? submitBtn.getAttribute('data-texto-disponible') : submitBtn.getAttribute('data-texto-agotado');
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', update); });

  /* Tarjetas de pack (sustituyen al desplegable cuando hay una sola opción con pocos valores) */
  var packs = form.querySelectorAll('[data-qn-pack]');
  if (packs.length && selects[0]) {
    packs.forEach(function (card) {
      card.addEventListener('click', function () {
        selects[0].value = card.getAttribute('data-value');
        selects[0].dispatchEvent(new Event('change', { bubbles: true }));
        packs.forEach(function (c) {
          var activa = c === card;
          c.classList.toggle('qn-pack--activo', activa);
          c.setAttribute('aria-checked', activa ? 'true' : 'false');
        });
      });
    });
  }
}

/* Pausa el vídeo del banner si el usuario prefiere menos movimiento */
function initBannerVideoMotion() {
  if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.querySelectorAll('video.qn-banner__img').forEach(function (v) {
    v.pause();
    v.removeAttribute('autoplay');
  });
}

/* Reproduce el vídeo de la sección "Vídeo demostración" al llegar a la vista */
function initVideoAutoplayEnScroll() {
  var videos = document.querySelectorAll('.qn-video__el');
  if (!videos.length || !('IntersectionObserver' in window)) return;
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducedMotion) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var v = entry.target;
      if (entry.isIntersecting) {
        v.muted = true;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        v.pause();
      }
    });
  }, { threshold: 0.5 });
  videos.forEach(function (v) { io.observe(v); });
}

/* Marquesina infinita (logos / estrellas) */
function initMarquee() {
  document.querySelectorAll('.qn-marquee__track').forEach(function (track) {
    if (track.dataset.qnDuplicated || track.dataset.qnMarqueeReady) return;
    track.innerHTML += track.innerHTML;
    track.dataset.qnDuplicated = 'true';
  });
}

/* Muestra el resto de las reseñas al pulsar "Ver más opiniones" */
function initResenasVerMas() {
  document.querySelectorAll('[data-qn-resenas-boton]').forEach(function (boton) {
    var grid = boton.closest('.qn-resenas').querySelector('[data-qn-resenas-grid]');
    if (!grid) return;
    boton.addEventListener('click', function () {
      grid.querySelectorAll('.qn-resenas__card--extra[hidden]').forEach(function (card) {
        card.hidden = false;
      });
      boton.hidden = true;
    });
  });
}

/* Barra de compra fija (móvil y ordenador): visible siempre que el botón principal no se vea en pantalla */
function initBarraCompra() {
  var barra = document.querySelector('[data-qn-barra-compra]');
  var principal = document.querySelector('[data-qn-submit]');
  if (!barra || !principal || !('IntersectionObserver' in window)) return;
  var boton = barra.querySelector('[data-qn-barra-boton]');
  new IntersectionObserver(function (entries) {
    barra.classList.toggle('qn-barra-compra--visible', !entries[0].isIntersecting);
  }).observe(principal);
  if (boton) boton.addEventListener('click', function () { principal.click(); });
}


/* Añadir al carrito sin salir de la página: abre el cajón del carrito */
function initCajonCarrito() {
  var form = document.querySelector('[data-qn-form-producto]');
  var cart = document.querySelector('cart-drawer');
  if (!form || !cart || !window.routes) return;
  var btn = form.querySelector('[data-qn-submit]');
  var ocupado = false;
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (ocupado || (btn && btn.disabled)) return;
    ocupado = true;
    if (btn) btn.setAttribute('aria-busy', 'true');
    var fd = new FormData(form);
    fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
    fd.append('sections_url', window.location.pathname);
    cart.setActiveElement(document.activeElement);
    fetch(window.routes.cart_add_url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (resp) {
        if (resp.status) { window.location = window.routes.cart_url; return; }
        cart.classList.remove('is-empty');
        cart.renderContents(resp);
      })
      .catch(function () { window.location = window.routes.cart_url; })
      .finally(function () { ocupado = false; if (btn) btn.removeAttribute('aria-busy'); });
  });
}
document.addEventListener('DOMContentLoaded', initCajonCarrito);


/* Cajón del carrito: cuenta atrás que cierra la ventana (no vacía el carrito) */
function initRelojCajon() {
  var cart = document.querySelector('cart-drawer');
  if (!cart) return;
  var fin = null, timer = null;
  function formato(s) { var m = Math.floor(s / 60), r = s % 60; return (m < 10 ? '0' : '') + m + ':' + (r < 10 ? '0' : '') + r; }
  function parar() { if (timer) { clearInterval(timer); timer = null; } fin = null; }
  function tick() {
    var reloj = cart.querySelector('[data-qn-reloj]');
    if (!reloj) { parar(); return; }
    var resta = Math.max(0, Math.round((fin - Date.now()) / 1000));
    var t = reloj.querySelector('[data-qn-reloj-tiempo]');
    if (t) t.textContent = formato(resta);
    if (resta <= 0) { parar(); if (typeof cart.close === 'function') cart.close(); }
  }
  function revisar() {
    var abierto = cart.classList.contains('active');
    var reloj = cart.querySelector('[data-qn-reloj]');
    if (abierto && reloj && !timer) {
      var seg = parseInt(reloj.getAttribute('data-segundos'), 10) || 240;
      fin = Date.now() + seg * 1000;
      timer = setInterval(tick, 500); tick();
    } else if (!abierto && timer) { parar(); }
  }
  new MutationObserver(revisar).observe(cart, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
  revisar();
}
document.addEventListener('DOMContentLoaded', initRelojCajon);
